import { privateKeyFromPem as pkiPrivateKeyFromPem } from 'node-forge/pki'
import type { PrivateKey } from './re-exports'

export const privateKeyFromPem = (privateKeyPem: string): Maybe<PrivateKey> =>
	pkiPrivateKeyFromPem(privateKeyPem)
